(ns common.audit-ops)

;;
;; map of allowed audit operations
;; keyword [icon-color icon class filter-group]
;; where filter-groups [:updates :status-changes :comments :interactions :emails :system]
;;
(def audit-ops
  {:op.oppo/create ["grey" "fal fa-plus-circle" :status-changes]
   :op.oppo/update ["info" "fal fa-redo" :updates]
   :op.oppo/any-update ["grey" "fal fa-plus" :updates]
   :op.oppo/move ["grey" "fal fa-arrow-right" :updates]
   :op.oppo/migrate ["grey" "fal fa-plus" :updates]
   :op.oppo/put-on-hold ["warning" "fal fa-pause-circle" :status-changes]
   :op.oppo/pass ["error" "fal fa-ban" :status-changes]
   :op.oppo/add-to-portfolio ["success" "fal fa-plane-departure" :status-changes]
   :op.oppo/resurrect ["grey" "fa-arrow-left" :status-changes]
   :op.oppo/reactivate ["grey" "fa-arrow-left" :status-changes]
   :op.oppo/add-flag ["info" "fas fa-star" :updates]
   :op.oppo/delete-flag ["info" "fas fa-star" :updates]
   :op.oppo/add-attachment ["info" "fal fa-redo" :updates]
   :op.oppo/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.oppo/disable ["grey" "fal fa-trash-alt" :updates]

   :op.company/create ["grey" "al fa-plus-circle" :updates]
   :op.company/update ["info" "fal fa-plus" :updates]
   :op.company/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.company/disable ["grey" "fal fa-trash-alt" :updates]
   :op.company/entity-merge ["info" "fal fa-redo" :updates]

   :op.kpi-report/submit ["info" "fal fa-plus" :updates]
   :op.kpi-report/review ["info" "fal fa-plus" :updates]

   :op.account/create ["grey" "fal fa-plus" :system]
   :op.account/login-token-create ["grey" "fal fa-plus" :system]
   :op.account/login-token-update ["grey" "fal fa-plus" :system]
   :op.account/login-token-remove ["grey" "fal fa-plus" :system]
   :op.account/migrate ["grey" "fal fa-plus" :system]
   :op.account/change-password-with-token ["grey" "fal fa-plus" :system]
   :op.account/update ["grey" "fal fa-plus" :system]

   :op.person/create ["grey" "fal fa-user-plus" :updates]
   :op.person/update ["info" "fal fa-redo" :updates]
   :op.person/entity-merge ["info" "fal fa-redo" :updates]
   :op.person/migrate ["grey" "fal fa-plus" :system]
   :op.person/disable ["grey" "fal fa-trash-alt" :system]

   :op.phone-call/log ["success" "fal fa-phone" :interactions]

   :op.involvement/create ["grey" "fal fa-plus" :system]
   :op.involvement/update ["grey" "fal fa-plus" :system]
   :op.involvement/disable ["grey" "fal fa-trash-alt" :system]

   :op.lead-source/create ["grey" "fal fa-plus" :system]
   :op.lead-source/update ["grey" "fal fa-plus" :system]

   :op.detailed-lead-source/create ["grey" "fal fa-plus" :system]
   :op.detailed-lead-source/update ["grey" "fal fa-plus" :system]

   :op.person-title/create ["grey" "fal fa-plus" :system]
   :op.person-title/update ["grey" "fal fa-plus" :system]

   :op.funding-round/create ["grey" "fal fa-plus" :system]
   :op.funding-round/update ["grey" "fal fa-plus" :system]

   :op.meeting/log ["success" "fal fa-user-friends" :interactions]

   :op.comment/create ["info" "fal fa-comment" :comments]

   :op.process/start ["grey" "fal fa-plus" :system]
   :op.process/signal ["grey" "fal fa-plus" :system]
   :op.process/timeout ["grey" "fal fa-plus" :system]
   :op.process/cancel ["grey" "fal fa-plus" :system]
   :op.process/done ["grey" "fal fa-plus" :system]

   :op.tenant/create ["grey" "fal fa-plus" :system]
   :op.tenant/update ["grey" "fal fa-plus" :system]
   :op.tenant/migrate ["grey" "fal fa-plus" :system]
   :op.tenant/add-tag ["grey" "fal fa-plus" :system]
   :op.tenant/delete-tag ["grey" "fal fa-plus" :system]
   :op.tenant/add-pass-reason ["grey" "fal fa-plus" :system]
   :op.tenant/delete-pass-reason ["grey" "fal fa-plus" :system]
   :op.tenant/update-plan ["grey" "fal fa-plus" :system]
   :op.tenant/mcp-terms-accepted ["grey" "fal fa-plus" :system]
   :op.tenant/disable-tenant ["grey" "fal fa-plus" :system]
   :op.tenant/reactivate-tenant ["grey" "fal fa-plus" :system]
   :op.task/create ["info" "fal fa-clipboard-list" :updates]
   :op.task/update ["info" "fal fa-redo" :updates]
   :op.task/assign ["info" "fal fa-clipboard-user" :updates]
   :op.task/complete ["info" "fal fa-clipboard-check" :updates]
   :op.task/reactivate ["info" "fal fa-clipboard-list" :updates]
   :op.task/migrate ["info" "fal fa-plus" :updates]
   :op.task/disable ["grey" "fal fa-trash-alt" :updates]

   :op.webentry/resolve ["info" "fal fa-redo" :updates]

   :op.attachment/upload ["info" "fal fa-paperclip" :updates]

   :op.tag/add ["info" "fal fa-tag" :updates]
   :op.tag/create ["info" "fal fa-tag" :updates]
   :op.tag/delete ["info" "fal fa-tag" :updates]
   :op.tag/remove ["info" "fal fa-tag" :updates]

   :op.stage/create ["grey" "fal fa-plus" :system]
   :op.stage/update ["info" "fal fa-plus" :updates]
   :op.stage/move ["grey" "fal fa-arrow-right" :updates]
   :op.stage/disable ["grey" "fal fa-trash-alt" :system]
   :op.stage/remove ["grey" "fal fa-trash-alt" :system]

   :op.pass-reason/create ["grey" "fal fa-plus" :system]
   :op.pass-reason/disable ["grey" "fal fa-trash-alt" :system]
   :op.pass-reason/remove ["grey" "fal fa-plus" :system]
   :op.pass-reason/update ["grey" "fal fa-plus" :system]

   :op.account/accept-terms ["grey" "fal fa-plus" :system]
   :op.commitment/create ["grey" "fal fa-plus" :system]
   :op.commitment/disable ["grey" "fal fa-plus" :system]
   :op.commitment/update ["grey" "fal fa-plus" :system]
   :op.fund-commitment/create ["grey" "fal fa-plus" :system]
   :op.fund-commitment/disable ["grey" "fal fa-plus" :system]
   :op.fund-commitment/update ["grey" "fal fa-plus" :system]

   :op.sale-agreement/create ["grey" "fal fa-plus" :system]
   :op.sale-agreement/disable ["grey" "fal fa-plus" :system]
   :op.sale-agreement/update ["grey" "fal fa-plus" :system]

   :op.holding/create ["grey" "fal fa-plus-circle" :updates]
   :op.holding/update ["info" "fal fa-plus" :updates]
   :op.holding/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.holding/disable ["grey" "fal fa-trash-alt" :updates]

   :op.real-estate/create ["grey" "fal fa-plus-circle" :updates]
   :op.real-estate/update ["info" "fal fa-plus" :updates]
   :op.real-estate/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.real-estate/disable ["grey" "fal fa-trash-alt" :updates]

   :op.other-asset/create ["grey" "fal fa-plus-circle" :updates]
   :op.other-asset/update ["info" "fal fa-plus" :updates]
   :op.other-asset/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.other-asset/disable ["grey" "fal fa-trash-alt" :updates]

   :op.fof-asset/create ["grey" "fal fa-plus-circle" :updates]
   :op.fof-asset/update ["info" "fal fa-plus" :updates]
   :op.fof-asset/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.fof-asset/disable ["grey" "fal fa-trash-alt" :updates]

   :op.investor/create ["grey" "fal fa-plus-circle" :updates]
   :op.investor/update ["info" "fal fa-plus" :updates]
   :op.investor/entity-merge ["info" "fal fa-redo" :updates]
   :op.investor/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.investor/disable ["grey" "fal fa-trash-alt" :updates]

   :op.fund/create ["grey" "fal fa-plus-circle" :updates]
   :op.fund/update ["info" "fal fa-plus" :updates]
   :op.fund/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.fund/disable ["grey" "fal fa-trash-alt" :updates]

   :op.entity/create ["grey" "fal fa-plus-circle" :updates]
   :op.entity/update ["info" "fal fa-plus" :updates]
   :op.entity/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.entity/disable ["grey" "fal fa-trash-alt" :updates]

   :op.fundraising-opportunity/create ["grey" "fal fa-plus-circle" :updates]
   :op.fundraising-opportunity/update ["info" "fal fa-plus" :updates]
   :op.fundraising-opportunity/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.fundraising-opportunity/disable ["grey" "fal fa-trash-alt" :updates]
   :op.fundraising-opportunity/put-on-hold ["warning" "fal fa-pause-circle" :status-changes]
   :op.fundraising-opportunity/lost ["error" "fal fa-ban" :status-changes]
   :op.fundraising-opportunity/won ["success" "fal fa-plane-departure" :status-changes]
   :op.fundraising-opportunity/resurrect ["grey" "fa-arrow-left" :status-changes]
   :op.fundraising-opportunity/move ["grey" "fal fa-arrow-right" :updates]

   :op.sales-opportunity/create ["grey" "fal fa-plus-circle" :updates]
   :op.sales-opportunity/update ["info" "fal fa-plus" :updates]
   :op.sales-opportunity/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.sales-opportunity/disable ["grey" "fal fa-trash-alt" :updates]
   :op.sales-opportunity/put-on-hold ["warning" "fal fa-pause-circle" :status-changes]
   :op.sales-opportunity/lost ["error" "fal fa-ban" :status-changes]
   :op.sales-opportunity/won ["success" "fal fa-plane-departure" :status-changes]
   :op.sales-opportunity/resurrect ["grey" "fa-arrow-left" :status-changes]
   :op.sales-opportunity/move ["grey" "fal fa-arrow-right" :updates]

   :op.exit-opportunity/create ["grey" "fal fa-plus-circle" :updates]
   :op.exit-opportunity/update ["info" "fal fa-plus" :updates]
   :op.exit-opportunity/remove-attachment ["grey" "fal fa-trash-alt" :updates]
   :op.exit-opportunity/disable ["grey" "fal fa-trash-alt" :updates]
   :op.exit-opportunity/put-on-hold ["warning" "fal fa-pause-circle" :status-changes]
   :op.exit-opportunity/lost ["error" "fal fa-ban" :status-changes]
   :op.exit-opportunity/won ["success" "fal fa-plane-departure" :status-changes]
   :op.exit-opportunity/resurrect ["grey" "fa-arrow-left" :status-changes]
   :op.exit-opportunity/move ["grey" "fal fa-arrow-right" :updates]

   :op.kyc-profile/disable ["grey" "fal" "fa-trash-alt" :updates]
   :op.contract-kyc-profile/disable ["grey" "fal" "fa-trash-alt" :updates]
   :op.option/merge ["info" "fal fa-plus" :updates]})
